export const ru = {
  locale: 'ru',
  messages: {


    //Global
    cancel: 'Закрыть',
    discard: 'Discard',
    save: 'Сохранить',
    saving: 'Сохранение',
    default: 'По умолчанию',
    make_default: 'Сделать по умолчанию',
    select: 'Выбрать',
    preview: 'Просмотр',
    yes: 'Да',
    no: 'Нет',
    ok: 'ОК',
    done: 'Готово!',
    verify: 'Подтвердить',
    publish: 'Опубликовать',
    apply: 'Применить',
    reset: 'Сбросить',
    manage: 'Править',
    not_attached: 'Не прикреплены',
    attached: 'Прикреплены',
    link: 'Ссылка',
    target: 'Метод открытия ссылки',
    back: 'Назад',
    add: 'Добавить',
    add_new_one: 'Добавить',
    edit: 'Изменить',
    edit_site: 'Edit Site',
    not_editable: 'Не редактируется',
    hide: 'Скрыть',
    delete: 'Удалить',
    required: 'Обязательный',
    not_required: 'Не обязательный',
    label: 'Название поля',
    text: 'Text',
    placeholder: 'Местозаполнитель',
    pattern: 'Шаблон',
    errorMessage: 'Error Message',
    visibility: 'Видимость',
    position: 'Расположение',
    coming_soon: 'Скоро',
    isRequired: 'Обязательное поле',
    isVisible: 'Видимость',
    firstname: 'Имя',
    lastname: 'Фамилия',
    fullname: 'Полное имя',
    description: 'Описание',
    keywords: 'Ключевые слова',
    url: 'URL',
    address: 'Address',
    city: 'City',
    desktop: 'Desktop',
    enabled: 'Enabled',
    enable: 'Enable',
    disabled: 'Disabled',
    disable: 'Disable',
    input: 'Input',
    goToHome: 'Go to Homepage',
    tryAgainLater: 'Please try again later',
    hours: 'Hours',

    // Not Found Page
    notFoundHeader: 'Oops... Page not found',
    notFoundTxt: "The page you are looking for doesn't seem to exist",

    // Social
    twitter: 'Twitter',
    social_links: 'Social Links',
    twitter_img_ratio: "Allowed image image size for a banner is 600 X 335 px.",
    open_graph_img_ratio: "Allowed image image size for a banner is 1200 X 630 px.",
    social_img_size_max: "Maximum image size for a banner is 3 MB.",

    // Error Messages
    general_error_msg_title: 'Произошла неизвестная ошибка.',
    general_error_msg_description: 'Произошла неизвестная ошибка.',

    // Placeholder messages
    description_placeholder: 'Your description here...',
    shema_description_placeholder: 'Enter company description',
    site_name_placeholder: 'Site Name here...',
    title_placeholder: 'Title here...',
    state_region_placeholdern: 'Enter state/region name',
    schema_city_placeholder: 'Enter city name',
    postal_code_placeholder: 'Enter postal code',
    phone_number_placeholder: 'Enter contact phone number',
    schema_social_placeholder: "Enter company's profile pages URLs",
    schema_email_placeholder: 'Enter contact email address',
    country_placeholder: 'Enter country name',
    schema_address_placeholder: ' Enter street address',
    url_placeholder: 'URL here...',
    summary_card_placeholder: 'Summary Card',
    username_placeholder: 'Username here...',
    name_placeholder: 'Name here...',
    image_alt_placeholder: 'Image alt here...',
    organization_placeholder: 'Organization',
    past_link_placeholder: 'Paste link here',
    username: 'Username',

    // Tooltips
    title_tooltip: 'Characters limitation for page title is 10-60 characters.',
    description_tooltip: 'Page description is best to consist of at least one keyword. Characters limitation - 50-320 characters.',
    keywords_tooltip: "It's the best to have them not more than 10% of the description lenght",
    twitter_img_tooltip: 'Image size should be 600 x 335 pixels',
    open_graph_img_tooltip: 'Image size should be 1200 x 630 pixels',
    schema_tooltip: "Company's profile pages on different resources, such as Facebook, Twitter, Google+, Instagram, Youtube, LinkedIn, Wikipedia, etc. You can add as many URLs, as you wish.",

    // Validation Messages
    email_required: 'Пожалуйста, введите адрес эл. почты.',
    invalid_mail: 'Неверный формат адреса эл. почты.',
    input_mail: 'Введите адрес электронной почты.',
    password_required: 'Пожалуйста, введите свой пароль.',
    inconsistent_passwords: 'Пароли не совпадают.',
    input_phone_number: 'Введите свой номер телефона.',
    invalid_phone_number: 'Неверный формат номера телефона.',
    please_confirm_password: 'Пожалуйста, подтвердите свой пароль.',
    invalid_password: 'Пароль должен состоять из 8-15 символов и содержать строчные и заглавные буквы, специальные символы и хотя бы 1 цифру.',
    required_field: 'Это поле обязательно для заполнения.',
    site_name_msg: 'The site name can contain only lowercase Latin letters, numbers, 2-30 characters.',
    invalid_host: 'Неверное имя хоста.',
    invalid_url: 'Неверная ссылка.',
    empty_string: 'Пустая строка не допускается.',
    company_name: 'Название компании',
    company_name_already_exists: 'Компания с таким названием уже существует.',
    input_company_name: 'Пожалуйста, введите название компании.',
    input_script_name: 'Пожалуйста, введите название скрипта.',
    input_script: 'Пожалуйста, введите скрипт.',
    input_script_id: 'Введите идентификатор {name} скрипта.',
    invalid_company_name: 'Название компании может содержать только строчные и заглавные буквы, цифры, "&" и пробел.',
    seo_settings_title: 'Maximum length for the page title is 100 characters. Recommended length is 10-70 characters',
    seo_settings_description: 'Maximum length for the page description is 500 characters. Recommended length is 50-320 characters.',
    seo_settings_keywords: 'Maximum length for the keywords section is 1000 characters.',
    integration_id_label: '{name} ID',
    support_phone_validation_msg: 'Maximum length for the field is 25 characters.',

    // Filter
    filter: 'Filter',
    sort_by: 'Sort by:',
    sort_by_name: 'Name (A- Z)',
    sort_by_name_desc: 'Name (Z- A)',
    sort_by_creation_new_old: 'Date created (New-Old)',
    sort_by_creation_old_new: 'Date created (Old-New)',

    // Login
    login: 'Логин',
    email: 'Эл. почта',
    password: 'Пароль',
    remember_me: 'Помнить',
    sign_up: 'Зарегистрироваться',
    dont_have_account: 'Не зарегистрированы?',
    register_now: 'Зарегистрироваться',
    forgot_password: 'Забыли пароль?',
    reset_password: 'Reset password',
    or: 'Или',
    confirm_password: 'Подтвердите пароль',
    phone_number: 'Номер телефона',
    all_projects: 'All projects',
    all_roles: 'All roles',
    set_password: 'Set Password',
    password_info: "Please note, this is recommended pattern to have for user's Password from security standpoint, however you can weaken it up to having 6-20 Latin letters, numbers or special characters.",

    // Registration Page
    registration: 'Регистрация',
    register: 'Регистрация',
    agreement1: 'Я прочитал ',
    agreement2: 'соглашение',
    human: 'Пожалуйста, подтвердите, что Вы не робот.',
    name_validation_message: 'Пожалуйста, введите правильное имя.',
    first_name_required_msg: 'Please input your First name.',
    last_name_required_msg: 'Please input your Last name.',
    agreement_required_msg: 'Please confirm that you have read the agreement.',

    // Forgot Password

    go_to_login: 'Перейти в Логин',
    send_verification_code: 'Отправить код подтверждения',
    mobile: 'Мобильный',
    recover_by: 'Восстановить пароль по',
    verification_code_sent: 'Код подтверждения был успешно отправлен.',
    password_changed: 'Пароль был успешно изменен.',
    change_password_btn: 'Change Password',
    reset_code: 'Reset code',
    password_reset_code: 'Input password reset code here',
    reset_code_required: 'Please input reset code',
    get_reset_code: 'Get reset code',
    send_reset_code_again: 'Send again',
    reset_code_sent: 'Your password reset code has been successfully sent',
    repeat_in: 'Repeat in',
    forgot_password_section: 'Forgot password',
    change_password: 'Change Password',

    // Account Verification

    email_verification: 'Подтвердить адрес эл. почты',
    mobile_verification: 'Подтвердить номер телефона',
    verification_code: 'Код подтверждения',
    resend_verification_code: 'Отправить код подтверждения',
    confirm_verification: 'Подтвердить',
    verification_code_required: 'Введите код подтверждения',
    verification_code_resent: 'The verification code has been resent successfully.',

    // Top Menu
    profile: 'Профиль',
    logout: 'Выйти',

    // Projects
    projects: 'Проекты',
    add_new_site: 'Создать сайт',
    my_sites: 'Мои Сайты',
    delete_site: 'Вы уверены, что хотите удалить сайт - {site}?',
    site_state: { 1: 'Активный', 2: 'Заблокированный', 3: 'Пробный' },
    change_status: "Change Status",
    change_temp_attention_warning: "Be aware changing template will remove all configurations from DGbuilder Admin panel made for current template.  Configurations from other admin panels won't be changed.",
    delete_text: "Deleting a site cannot be undone. All data for the site will be lost and cannot be recovered. Please input your account password in order to permanently delete the site.",
    all_companies: "All companies",
    status_blocked_text: "In Blocked status the site is temporarily unavailable.",
    status_live_text: "In Live status the site is fully functional.",
    check_password_text: "Please input your account password in order to change the site status.",
    company: 'Company',
    /* My Profile */

    //Profile
    myProfile: 'Мой профиль',
    adminTools: 'Admin Tools',
    users: 'Users',
    auditLogs: 'Audit Logs',

    change_pass_title: 'Нажмите изменить для изменения текущего пароля.',
    current_password: 'Текущий пароль',
    new_password: 'Новый пароль',
    confirm_new_password: 'Подтвердить новый пароль',

    new_email: 'Новый Email',
    save_email_note: 'Ваш новый Email будет сохранен только после подтверждения.',
    check_email_note: 'Пожалуйста, проверьте свою электронную почту для проверки кода.',

    new_mobile: 'Новый номер телефона',
    save_mobile_note: 'Ваш новый номер телефона будет сохранен только после проверки.',
    check_mobile_note: 'На ваш номер телефона отправлено SMS с кодом подтверждения.',
    confirm_code: 'Подтвердить код',
    first_name_validation_msg: 'First name can only contain Latin letters, dash and a space.',
    last_name_validation_msg: 'Last name can contain 2-50 characters: only Latin letters, dash, apostrophe and spaces.',
    incorrect_password: 'Your current password is incorrect',
    status_has_changed: "Status has been successfully changed",
    choose_company_first: "Please select the Company first.",
    created_by: "Created By",
    companies: "Companies",
    add_company: "Add Company",
    add_new_company: "Add new company",

    roles: 'Roles',

    // Settings
    settings: 'Настройки',
    overview: 'Обзор',
    languages: 'Языки',
    language: 'Язык',
    language_bar: 'Language Bar',
    banners_managment: 'Banner Management',
    captcha: 'Защитный код',
    currencies: 'Валюты',
    sms: 'SMS',
    smtp: 'SMTP',
    search_here: 'Поиск',
    products: 'Продукты',
    domains: 'Домены',
    logos: 'Логотипы',
    destination: 'Адрес',
    general_settings: 'Общие настройки',
    cookies_storing: 'Cookies storing period in days',
    go_to_settings: 'Перейти в настройки',
    api_key: 'API ключ',
    secret_key: 'Секретный ключ',
    setting_changed: "Данные успешно обновлены.",
    click_here: 'Кликните сюда',
    on: 'On',
    off: 'Off',

    copy_intercom_id: 'Скопируйте идентификатор «Интерком» и вставьте его в поле ниже.',
    copy_hotjar_id: 'Скопируйте идентификатор Hotjar и вставьте его в поле ниже.',
    copy_zendesk_id: 'Скопируйте идентификатор виджетов из кода встраивания чата Zendesk.',
    copy_google_id: 'Скопируйте идентификатор отслеживания Google Analytics и вставьте его в поле ниже.',
    copy_google_console_id: 'To verify website ownership, click on HTML tag verification method in your Google Search Console account, copy the code (content value in meta tag) and paste it in the field below. Afterwards, click Verify in Verify Ownership popup in your Google Search Console account.',
    learn_more: 'Узнать больше…',
    integrate: 'Интегрировать',
    enter_script_name: 'Введите название скрипта',
    enter_head_script: 'Введите скрипт заголовка',
    enter_body_script: 'Введите скрипт тега тела',
    enter_scrpt_id: 'Введите идентификатор {name}',
    google_console_label: 'Google site verification code',
    google_console_error_msg: 'Please input your Google site verification code',
    google_console_placeholder: 'Please input your Google site verification code',
    whatsapp_number_label: 'WhatsApp number',
    whatsapp_number_placeholder: 'Enter your WhatsApp number',
    whatsapp_number_error_msg: 'Enter your WhatsApp number',

    // Products
    choose_products: 'Выберите, какие продукты вы хотите активировать для своего сайта.',
    sport_description: 'При активации продукта Спортсбук, Вы получите доступ к всеобъемлющему многоязычному, мультивалютному настраиваемому интерфейсу, с пре-матч и лайв событиями для более чем 65 видов спорта, 7500 лиг по всему миру и более 3 000 маркетов.',
    casino_description: 'При активации продукта Казино, Вы получите доступ к более чем 3 000 казино играм от топ казино провайдеров.',
    sportsbook: 'Спортсбук',
    casino: 'Казино',
    deactivate: 'Деактивировать',
    activate: 'Активация',

    // Overview
    statuses: 'Статусы',
    preview_site_label: 'Просмотр сайта',
    rename_site_label: 'Переименовать сайт',
    duplicate_site_label: 'Дублировать сайт',
    delete_site_label: 'Удалить сайт',
    quick_actions: 'Быстрые действия',
    overview_desc: 'Here you can see which settings are already done for your website and which ones are missing. Please note, that all of them are required for going live.',
    site_address: 'Адрес сайта',

    add_language: 'Добавить новый язык',
    language_delete_confirmation: 'All language-specific settings and content (banners, forms, menu items, SEO, etc.) will be recovered after the language reactivation.',

    monochrome: 'Monochrome',
    white: 'White',
    colored: 'Colored ',
    colored_with_background: 'Colored with background',
    default_state_type: 'Default State Type',
    hover_state: 'Hover State',

    credit_percent: 'Кредит %',
    debit_percent: 'Дебет %',
    state: 'Статус',
    currency: 'Валюта',
    add_currency: 'Добавить новую валюту',
    currency_delete_confirmation: 'The currency will be removed from the list on the website. Players using this currency will not be affected. If you want to fully deactivate the currency and not support it any more, please contact your account manager.',


    // Domain
    add_domain: 'Добавить новый домен',
    connect_domain: 'Подключите свой домен',
    domain_required: 'Пожалуйста, введите домен.',
    domain_validation_message: 'Пожалуйста, введите действительный домен',
    domain_name: 'Имя домена',
    your_domain_name: 'Введите имя вашего домена',
    status: 'Статус',
    remove_domain: 'Удалить домен',
    no_data: 'Нет данных',
    pending: 'В ожидании',
    active: 'Активный',
    are_you_sure_to_remove_domain: 'Вы уверены, что хотите удалить {name} домен?',
    domain_added: 'Домен добавлен',
    verification_sent: 'Проверка домена успешно отправлена',
    name_servers_info: "Name Servers information",
    domain_redirection: 'Domain Redirection',
    no_rule: 'No rule created yet',
    no_rule_description: 'Here you can add a permanent redirection rule for one of your website’s active domains.',
    add_new_rule: 'Add a New Rule',
    domain_rules_desc: 'Here you can add a permanent redirection rule for one of your website’s active domains.',

    forwarding_url: 'Forwarding URLs',
    destination_url: 'Destination URL',
    select_domain: 'Select a domain',
    delete_the_rule: 'Delete the rule',
    delete_rule: 'Delete rule',
    delete_rule_conf: 'Are you sure you want to delete the rule.',
    rule_delete_warning: '{name} cannot be deleted because there is a domain redirection rule related to it. Please delete or edit the rule first.',
    rule_delete_button: 'Ok, Got it',
    rule_delete_warning_title: 'Delete domain',

    domain_instructions_titile_1: 'Залогиньтесь в своего домен провайдера.',
    domain_instructions_paragraph_1: 'Your domain provider is the company where you purchased it (e.g., GoDaddy, eNom, 1and1).',

    domain_instructions_titile_2: 'Перейдите в настройки DNS/Nameservers вашего домена.',
    domain_instructions_paragraph_2_1: 'Найдите страницу управления доменом.',
    domain_instructions_paragraph_2_2: 'Перейдите в настройки DNS/Nameservers вашего домена.',

    domain_instructions_titile_3: 'Обновите серверы имен домена',
    domain_instructions_paragraph_3_1: 'Go to your domain DNS/Nameservers settings.',
    domain_instructions_paragraph_3_2: 'Replace ',
    domain_instructions_paragraph_3_3: ' all your current nameservers ',
    domain_instructions_paragraph_3_4: 'with these custom nameservers:',


    domain_instructions_titile_4: 'Проверьте подключение к домену',
    domain_instructions_paragraph_4: 'Проверьте, были ли обновлены настройки вашего домена.',
    reached_domains_hint: 'Maximum number of domains for your website is reached',
    domains_max_count_alert: `You have used <b>{count} of {limit}</b> your domains limit`,
    domains_max_count_reached_alert: `You have used <b>{count} of {limit}</b> your domains limit. Maximum number of domains for your website is reached.`,
   
    // SMTP
    provider: 'Провайдер',
    use_ssl: 'Использовать SSL',
    mail_from_required: 'Пожалуйста, введите адрес эл. почты отправителя.',
    mail_from: 'Эл. почта отправителя',
    mail_provider: 'Send email via',
    smtp_provider_Standart: 'Custom',
    smtp_provider_Digitain: 'Digitain',
    providers_description: 'SMTP configurations are necessary for sending emails to the players. You can either choose to send email via Digitain service or you can provide your custom SMTP configurations.',
    mail_from_name: 'Имя отправителя',
    mail_support: 'mail_support',
    host_required: 'Поле SMTP хост обязательно для заполнения.',
    smtp_host: 'SMTP хост',
    smtp_port: 'SMTP порт',
    smtp_password: 'SMTP пароль',
    smtp_user: 'SMTP пользователь',
    smtp_user_required: 'Поле SMTP пользователь обязательно для заполнения.',
    smtp_password_required: 'Поле SMTP пароль обязательно для заполнения.',
    smtp_port_required: 'Поле SMTP порт обязательно для заполнения.',
    mail_from_name_required: 'Пожалуйста, введите имя отправителя.',

    // Logo
    upload_logo: 'Click to Upload',
    upload_logo_drag: 'Drag and Drop Here or ',
    upload_mobile_logo: 'Upload Mobile Logo',
    image_size_max: 'Изображение должно быть меньше 1МБ.',
    image_type_error: 'Вы можете загрузить только файлы форматов JPG, SVG или PNG.',
    main_logo: 'Главный логотип',
    mobile_logo: 'Мобильная версия логотипа',
    default_logo: 'Default',
    favicon: 'Значок сайта',
    upload_favicon: 'Upload a Favicon',

    // Captcha
    invalid_input_value: 'Неверное значение',
    api_key_validation_msg: 'Please input valid API Key',
    secret_key_validation_msg: 'Please input valid Secret Key',

    // General
    age_restriction: 'Возрастное ограничение',
    market: 'Рынок',
    age_restriction_description1: 'Выберите возраст, который Вы бы хотели выбрать в качестве минимального требуемого возраста для своих пользователей.',
    age_restriction_description2: 'Люди до этого возраста не смогут зарегистрироваться.',
    market_restriontion_description: 'Select the market. Users from that market can register on your web page.',
    country: 'Страна',
    hidden_section_tooltip_msg: 'This functionality is available only for live projects.',
    age_restriction_validation_msg: 'Please input a natural number between 16 and 99.',

    // Banners
    status_live: 'Live',
    status_expired: 'Expired',
    status_scheduled: 'Scheduled',
    all_devices: 'All devices',
    all_statuses: 'All statuses',
    all_banners: 'All banners',
    banner_visibility: 'Visibility',
    next: 'Next',
    add_banner: 'Add Banner',
    edit_banner: 'Edit Banner',
    banner_name: "Banner Name",
    banner_name_required_message: 'Please input banner name',
    banner_name_validation_message: 'Banner name can only contain letters, numbers, dash and underscore',
    banner_language_required_message1: 'Please select at least one language',
    banner_language_required_message2: 'Please select language',
    alt_text: "Alt Text",
    alt_text_here: "Alt Text here...",
    url_link: "URL Link",
    how_to_open: "How to Open",
    start_date: "Start Date",
    set_start_date: "Please set Start Date",
    start_time: "Start Time",
    end_date: "End Date",
    end_date_required_message: "Please set End Date",
    end_time: "End Time",
    device_type: "Device type",
    enable_on_live_website: "Enable on Live Website",

    // Background image
    background_image: 'Background Image',
    all_backgrounds: 'All Backgrounds',
    body: 'Body',
    empty_background_image: 'In this section you can add and manage backgrounds for your website.',
    all_pages: 'All Pages',
    choose_fit: 'Fit type',
    background_type: 'Background type',
    background_position: 'Background Position',
    fill: 'Fill',
    repeat: 'Repeat',
    fit: 'Fit',

    // 3rd party integrations
    third_party_integrations: 'Интеграция сторонних продуктов',
    third_party_integrations_desc1: 'Enhance your website functionality by integrating 3-rd party products. Provide your unique ID for that product and all is set. Any other products can be added to the website by using',
    third_party_integrations_desc2: 'Custom Scripts.',
    my_integrations: 'Мои интеграции',
    integrate_custom_script: 'Вы можете интегрировать свой собственный скрипт.',
    third_party_delete_confirmation: 'Вы уверены, что хотите удалить "{script}" с панели администратора?',
    empty_integrations: 'You have integrated all available 3-rd party products.',
    third_party_integrations_empty_desc: "You don't have any integrated 3-rd party products yet.",

    show_on_website: 'Показать на сайте',
    show_on_website_tooltip: 'При отключении опции, иконка данной компании будет скрыта с домашней страницы Вашего сайта.',
    connect: 'Подсоединить',
    script: 'Скрипт',
    head_script: 'Внутри тега </ head />',
    body_script: 'Перед закрытием тега </ body>',

    //Custom Codes
    custom_codes: 'Пользовательские коды',
    custom_code_description: 'В этом модуле Вы можете добавить пользовательские скрипты и стили. Кроме этого, Вы можете изменить стили и интегрировать новые приложения в созданный Вами проект.',
    custom_script: 'Пользовательские скрипты',
    custom_scripts_description: 'You can integrate new applications or add different functionality to your website by adding custom scripts.',

    custom_styles: 'Пользовательские стили',
    edit_custom_style: 'Edit Custom Style',
    custom_styles_description: "You can change UI components' styles and further customize your website's frontend by adding custom styles.",
    script_name_validation_message: 'Name field can contain min. 2, max. 55 characters, Latin letters, numbers and the following special characters: (, -, _, ).',

    /* UI Customizaion */
    styles: 'Styles',
    secondary_menu: 'Secondary Menu',
    controls: 'Controls',
    forms_management: 'Forms management',
    always: 'Always',
    once: 'Once',
    never: 'Never',
    field_editing_options: 'Field Editing Options',
    field_editing_options_info: "You can choose how often the player can edit filed information in My Profile section of the website. The player can't edit/fill field information when option 'Never' is selected. Field information can be filled only once (it can't be edited if it's already filled) if you select 'Once' and it can be edited anytime, if the 'Always' option is selected.",
    // SEO
    seo: 'SEO',
    seo_settings: 'SEO Settings',
    seo_social: 'Open Graph/Twitter',
    seo_schema_markup: 'Schema Markup',
    seo_settings_intro: 'Optimize your website so that search engines will understand it better and give it higher rankings.',
    seo_social_intro: 'Manage the content that shows up when a website page is shared on social networks.',
    seo_schema_generator_intro: 'Schema markup is used to more clearly provide information about your company to search engines in order to understand your content. Your website schema will be automatically generated based on the information you fill in the following fields.',
    seo_openGraph: 'Open Graph',
    website: 'Website',
    twitter_username: 'Site (Twitter @username)',
    card: 'Card',
    copy_all_pages: 'Copy to All Pages',
    postal_code: 'Postal Code',
    state_region: 'State/Region',
    add_new: 'Add a New One',
    enter_page_title: 'Enter page title',
    seo_enter_keywords: 'Enter keywords',
    page_title_required: 'Page title field is required.',
    seo_schema_settings_saved: 'Seo Schema Settings saved',
    seo_settings_saved: 'Seo Settings saved',

    // Dragger
    dragger_message1: 'Click or drag here to upload',
    dragger_message2: '.jpg, .gif, .png',

    // Add-ons
    add_ons: 'Add-ons',
    add_ons_user_validation_title: '{name} market {version}',
    add_ons_user_validation_required_fields: 'Required fields for Registration and My Profile forms are:',
    add_ons_turkishservicevalidation_desc2: <div className="required-fields"><span>Country</span><span>Passport/ID number</span><span>First name</span><span>Last name</span><span>Birthdate</span></div>,
    add_ons_russianservicevalidation_desc2: <div className="required-fields"><span>Mobile Number</span><span>Email</span><span>Birthdate</span></div>,
    add_ons_russianservicevalidation2_desc2: <div className="required-fields"><span>Mobile Number</span><span>Email</span><span>Birthdate</span></div>,
    add_ons_brazilianservicevalidation_desc2: <div className="required-fields"><span>CPF number</span></div>,
    add_ons_user_info_validation_title: 'User info validation',
    add_ons_user_info_validation_subtitle: 'The service allows to verify user information for market residents before they can be registered on the website.',
    add_ons_cookies_title: 'Cookies',
    add_ons_cookies_subtitle: 'The website uses cookies for some of the applications. ',
    add_ons_cookies_required_fields: 'You can activate cookies message for the website, in order to inform site visitors. You can customize the message from admin panel.',
    add_ons_deactivate_txt: 'Are you sure you want to deactivate?',
    add_ons_turkishservice_deactivate_txt: 'Deactivate User info validation',
    cookies_deactivate_txt: 'Are you sure you want to deactivate?',

    //Colors
    colors: 'Цвета',
    new_set: 'Новая палитра',
    colorsets: 'Палитра цветов',
    background_colors: 'Цвета фонов',
    brand_colors: 'Цвета бренда',
    text_colors: 'Цвета текстов и иконок',
    reset_colorset: 'палитру по умолчанию',
    branding: 'Branding',

    //Edit Menu
    top_menu: 'Вторичное меню',
    main_menu: 'Главное меню',
    input_translation_key: 'Поле Ключ перевода обязательно для заполнения.',
    invalid_translation_key: 'Translation key can contain 2-50 characters: only Latin letters, numbers and special character _',
    input_required_name: 'Поле Имя обязательно для заполнения.',
    input_required_url: 'Поле URL обязательно для заполнения.',
    open_in_same_tab: 'Открыть в текущей вкладке',
    open_in_new_tab: 'Открыть в новой вкладке',
    open_in_new_window: 'Открыть в новом окне',
    none: 'Без значка',
    new: 'Новинка',
    promotion: 'Акция',
    hot: 'Горячее предложение',
    top: 'Топ',
    free: 'Free',
    premium: 'Premium',
    all_languages: "Все языки",
    add_new_menu_item: "Добавить новый элемент меню",
    edit_menu_item: "Изменить элемент меню",
    add_sub_item: 'Добавить подменю',
    menu_item_delete_confirmation: 'Do you want to delete this item?',

    nav_bar_icons: 'Nav bar icons',
    menu_font_size: 'Menu font size',
    small: 'small',
    medium: 'medium',
    font_style: 'Font style',
    large: 'big',
    bold: 'bold',
    regular: 'regular',
    font_case: 'Font case',
    uppercase: 'upper case',
    lowercase: 'lower case',
    original: 'original',
    menu_alignment: 'Menu alignment',
    left: 'left',
    center: 'center',
    right: 'right',
    menu_item_on_mobile: 'Show menu item icon in mobile',
    menu_item_on_desktop: 'Show menu item icon in desktop',

    badge: 'Значок',
    translation_key: 'Ключ перевода',
    name: 'Имя',
    fonts: 'Шрифты',
    main_font: 'Основной шрифт',
    pages: 'Страницы',
    header: 'Верхнее меню',
    footer: 'Нижнее меню',
    select_language: 'Выберите язык',
    ask_client: 'Запросить подписаться на рекламные и новостные рассылки',
    activate_age: 'Добавить чекбокс для подтверждения возраста клиента',
    registration_settings: 'Настройки регистрации',
    my_profile: 'Мой профиль',
    dashboard: 'Dashboard',

    error: "Error",
    related_fields_error_message1: 'Bank Name (list), Account Number and Account Holder name fields all need to be added to the form in order to proceed.',
    related_fields_error_message2: 'Your Country and City all need to be completed in order to proceed.',
    related_fields_error_message3: 'Bank name and Sheba number fields both need to be added to the form in order to proceed.',
    related_fields_error_message4: 'Please note, that the following 5 fields must be required in both Registration and My profile forms for the service to work correctly: Country, First name, Last name, Passport/ID number, Birthdate.',
    related_fields_error_message5: 'Please note, that the following 1 field must be required in both Registration and My profile forms for the service to work correctly: CPF number.',
    related_fields_error_message7: 'You must add an Email Address field before adding the Confirm Email field.',
    bonus: "Бонус",
    social_media: 'Социальные медиа',
    social_media_edit: "Edit Social Media",
    colored_logos: 'Colored Logos',
    footer_social_desc: "Choose social media icons and links that you would like to be displayed in your website's footer.",
    hide_section: 'Hide Section',
    more: "More",
    footer_more_desc: "Here you can choose the blocks that you would like to be displayed in your website's footer and edit their information.",
    show: "Show",
    show_section: 'Show Section',
    login_type_description: 'Show inline in header (for desktop)',
    copyright_validation_msg: 'Maximum length for the copyright information is 100 characters.',
    edit_terms_and_conditions_block: 'Edit Terms and Conditions block',
    edit_subscribtions_block: 'Edit Subscriptions block',

    //Form Creation
    recover_password: 'Восстановить пароль',
    timezone: 'Часовой пояс',
    sign_in: 'Вход в систему',
    type: "Тип контроля",
    wizard: 'Многостраничный',
    page: 'Страница',
    column: 'Колонка',
    inventory: 'Хранилище',

    Button: 'Кнопка',
    Captcha: 'Защитный код',
    Title: 'Заглавие',
    TextBox: 'Текстовое поле',
    Radio: 'Меню радиокнопки',
    Checkbox: 'Флажок',
    Select: 'Выпадающий список',
    Datepicker: 'Выбор даты',
    Link: 'Ссылка',
    Image: 'Картинка',
    ImageAlt: 'Image Alt',
    Switch: 'Переключатель',
    LinkButton: 'Кнопка ссылки',
    add_control_dragger_message: 'To add control drag and drop it here',
    chooseFieldType: 'Choose field type',
    drop_down: 'Drop Down',
    country_code: 'With country code',

    //Timer control
    secondary_left: 'Вторичное меню - Левая сторона',
    secondary_right: 'Вторичное меню - Правая сторона',
    main_left: 'Главное меню - Левая сторона',
    main_right: 'Главное меню - Правая сторона',
    show_time_zone: 'Часовой пояс',
    time_zone: 'Time zone',
    time_and_time_zone: 'Время и часовой пояс',

    // Create Project
    get_started: 'Начать',
    site_name: 'Название сайта',
    choose_name: 'Выберите название сайта',
    choose_template: 'Выберите шаблон сайта',
    creating_website: 'Создание сайта',
    site_already_exists: 'Сайт с таким названием уже существует.',
    creating_domain_msg: 'Создается субдомен для Вашего сайта.',
    creating_website_msg: 'Подождите пока создается Ваш сайт, это может занять несколько минут.',

    // Corner Radius
    corner_radius: 'Угловой радиус',
    left_bottom: 'Нижний левый угол',
    right_bottom: 'Нижний правый угол',
    right_top: 'Верхний правый угол',
    left_top: 'Верхний левый угол',
    all_corners: 'Все углы',
    input_fields: 'Выпадающие списки и текстовые области',
    buttons: 'Кнопки',

    // Icon set
    icon_sets: 'Icons Style',
    outline_icons: 'Outline Icons',
    filed_icons: 'Filled Icons',

    // Footer
    copyright: '© 2020 Digitain. Все права защищены.',
    social_medias: 'Социальные сети',
    menus: 'Меню',
    custom_ui_keys: {
      CustomerSupport: 'Customer Support',
      AgeRestriction: 'Age Restriction',
      CopyRightInfo: 'Copyright Info',
    //   PoweredByDigitain: 'Powered By Digitain',
      AboutCompany: 'About Company',
      MobileApps: 'Mobile Apps link',
      Language: 'Language dropdown'
    },

    image_block: 'Image Block',

    // Banners
    banners_description: 'Recommended image size in this section is {width}x{height}px. You can upload .jpg, .gif, .png images.',
    home_page_main_section: 'Главный',
    home_page_secondary_section: 'Secondary',
    home_page_top_casino_games_section: 'Top casino games',
    home_page_top_live_casino_games_section: 'Top live casino games',
    home_page_top_tv_games: 'Top TV Games',
    home_page_top_virtual_sport: 'Top Virtual Sport',
    home_page_top_small_banner_section: 'Top small',
    home: 'Главная страница',
    casino_page: 'Казино',
    casino_page_main_section: 'Главный',
    casino_lobby_page_main_section: 'Главный',
    myprofile_popup: 'Popup banners',
    myprofile_popup_main_section: 'Главный',
    banner_delete_confirmation: 'Are you sure you want to permanently delete the banner?',
    banner_delete_success: 'Banner has been successfully deleted',
    banner_enabled_success: 'Banner has been successfully enabled',
    banner_disabled_success: 'Banner has been successfully disabled',
    no_end_date: 'No End Date',
    view: 'View',
    add_banner_name: "Please add the image for banner",
    upload_image_size_max: 'Maximum image size is 2 MB.',
    upload_image_block_size_max: 'Maximum image size is 1 MB.',
    end_start_date_required_message: "Please set Start and End Date",
    end_and_start_date: "Start and End Date",
    date_and_time: "Set  Date and Time",
    description_here: 'Description here...',
    banners: 'Banners',
    slider_animation_type: "Slider Animation Type",
    animation_speed: "Animation Speed (Seconds)",
    autoplay: "Autoplay",
    pagination: "Pagination",
    show_arrows: "Show Arrows",

    // Promotions
    promotions: 'Promotions',
    promotions_description: 'In this section you can add and manage promotions for your website.',
    all_promotions: 'All promotions',
    empty_promotions: "You don't have any added promotions yet. Before adding a promotion please make sure that you have added at least one ",

    add_promotion: 'Add Promotion',
    edit_promotion: 'Edit Promotion',
    choose_promotion_category: 'Choose promotion category',
    detailed_info_page: 'Detailed info page',
    page_link: 'Page Link',
    detailed_info: 'Detailed info',
    img_alt_name: 'Image alt name',
    popup: 'Popup',
    add_button: 'Add button',
    action_button_name: 'Action button name',
    separate_landing_page: 'Separate page',
    separate_full_page: 'Full page',
    search_by_promotions: 'Search by promotions',

    reset_filters: 'Reset Filters',
    bulk_action: 'Bulk Action',
    selected_items: 'Selected items',
    archive_txt: 'Once you archive a promotion it will no longer be displayed on the website. Please confirm the action.',
    archive: 'Archive',
    name_tooltip: 'This name will be displayed on the website in case if there is no Promotion name added for a specific language.',
    action_button_tooltip: 'This name will be displayed on the button in case if there is no button name added for a specific language.',

    promotion_img_required_message: "Please add the image for promotion",
    img_alt_name_validation: 'Maximum length for alt text is 125 characters. ',
    promotion_name_required_message: 'Promotion name field is required.',
    promotion_name_validation_message: 'Promotion default name can contain 2-50 characters: letters, spaces, special characters and numbers.',
    category_field_required_message: 'Please select a category for the promotion',
    button_name_validation: 'Button name can contain 1-20 characters: letters, spaces and numbers.',
    button_name_required_message: 'Button name field is required.',
    page_link_required_message: 'Page link field is required.',
    promotion_delete_confirmation: 'Are you sure you want to permanently delete the promotion?',
    promotion_delete_success: 'Promotion has been successfully deleted',
    promotion_enabled_success: 'Promotion has been successfully enabled',
    promotion_disabled_success: 'Promotion has been successfully disabled',
    promotion_category_disabled_success: 'Promotion category has been successfully disabled',
    promotion_category_delete_success: 'Promotion category has been successfully deleted',
    promotion_category_enabled_success: 'Promotion category has been successfully enabled',
    promotion_category_delete_confirmation: 'Are you sure you want to permanently delete the promotion category?',
    promotion_category_add_btn_tooltip: 'To add a category, please select "All languages" option from the drop down above.',
    promotion_short_description: 'Short description',
    promotion_short_description_validation: 'Promotion short description can contain 2-150 characters: letters, spaces, special characters and numbers',

    archive_confirmation: 'Once you archive a promotion it will no longer be displayed on the website. Please confirm the action.',

    deposit: 'Deposit',
    common_required: 'Please input {name}',
    archive_promotions: "You don't have any archived promotions.",

    // Categories
    category: 'Category',
    categories: 'Categories',
    all_categories: 'All Categories',
    add_category: 'Add Category',
    edit_category: 'Edit Category',
    category_name_validation_message: 'Category name can contain 2-50 characters: only letters, spaces and numbers.',
    category_name: 'Category Name',
    category_icon: 'Category icon',

    category_name_required_message: 'Category name field is required.',
    category_icon_required_message: 'Please select a category icon',
    category_add_decs: 'To add a category, please select "All languages" option from the drop down above.',
    category_name_desc: 'This name will be displayed on the website in case if there is no Category name added for a specific language.',
    replace_promotion_category: 'Replace all fields values for all languages with these default values',
    promotion_add_btn_tooltip: 'To add a promotion, please select "All languages" option from the drop down above.',
    empty_promotion_category: "You don't have any added categories yet.",
    category_name_already_exists: 'Category with provided name already exists.',

    //Provider
    providers: "Providers",
    footer_providers_desc: "Choose casino providers that you would like to be displayed in your website's footer. You can switch between colored and monochrome versions of the logo.",
    provider_delete_confirmation: "Are you sure you want to delete {name} from footer?",
    add_provider: "Add Provider",
    edit_provider: 'Edit Provider',

    // License
    licenses: 'Лицензии',
    license_type: 'Licenses Type',
    license_body: 'Licensing Body',
    seal_id: 'Seal ID',
    license_description: 'Select license type, licensing body, input seal ID provided by the licensing body and choose under which domains the license script should be added. By default the license script will be added for all domains of your website.',
    add_more: 'Добавить',
    section_empty_title: 'This Section is Currently Empty',
    section_empty_text: 'Click "Add a New One" to see all the options available.',
    add_a_new_more: 'Add a new more',
    section_hidden_title: 'This Section is Currently Hidden.',
    section_hidden_text: 'Switch "Show Section" toggle to on to unhide this section.',
    logo: 'Логотип',
    license: 'License',
    license_domain_required: 'Please select at last one domain',
    license_seal_id_required: 'Please Input Seal ID',
    license_body_required: 'Please select Licensing Body',

    //Refer a friend
    refer_a_friend: 'Refer a friend',
    refer_a_friend_desc: "Please specify period in hours for which you want to keep the referrer's ID information for new registrations on the website.",
    refer_a_friend_hours_restriction: "Please specify a whole number between 0 and 720",

    // Featured Producds 
    featured_product_limit_msg: "Maximum number of featured products for your website is reached, you can only replace existing ones",
    featured_product_description: "Choose featured products that you would like to be displayed on your website.",
    featured_product: "Featured Products",
    featured_product_delete_confirmation: 'Are you sure you want to delete {name} from featured products?',
    featured_products_add: 'Add Featured Products',

    // banner pages
    Mainpage: 'Главная страница',
    MyProfile: 'Мой профиль',
    Casinopage: 'Казино',

    // rules
    rule_name_validation_message: 'Menu name can contain 2-50 characters including Latin letters, numbers and special characters - and _',
    rule_name_required: 'Menu name field is required',
    rule_ls_name_validation_message: 'Menu name can contain 2-50 characters',
    content_details: 'Content details',

    // widgets
    footer_management: 'Footer Management',

    //Color descriptons
    'brand-color-1': [
        "Unread messages count in header",
        "Copyright info in footer",
        "Selected and hovered odds in Sportsbook",
        "Buttons in Account popups and Sportsbook",
        "Illustrations (partially) in Account popups",
    ],

    'brand-color-2': [
        "Primary, secondary and tertiary buttons",
        "Selected menu items and subitems in header",
        "Selected item in mobile navigation bar",
        "Selected menu item in Right menu on mobile",
        "Opened menu item in Left menu on mobile",
        "Cookies and Announcement icon",
        "Floating menu item",
        "Selected and hovered chips in Casino filter",
        "Selected tab and sidebar item in Sportsbook",
        "Selected menu items in Rules",
    ],

    'brand-color-text': [
        "Primary buttons text in Account popups",
        "Selected and hovered odds text in Sportsbook", 
        "Selected tab text in Sportsbook",
    ],

    'background-color-1': [
        "Header background",
        "Mobile navigation bar items background",
        "Mobile left and right menu items background",
        "Sport Jackpot background",
        "Floating menu items background",
        "Top matches background",
        "Regulations menu and content background",
        "Sportsbook background",
        "Multi view sidebar background",
    ],

    'background-color-2': [
        "Website inner pages background",
        "Left menu background on mobile",
        "Cookies background",
        "Announcement background",
        "Sidebar background on desktop",
        "Floating menu background",
        "Promotion popup background",
        "Default odds background in Sportsbook",
        "Event dropdown and header background in Sportsbook",
    ],

    'background-color-3': [
        "Secondary menu subitems background",
        "Mobile apps, social media icons, language bar background in footer",
        "Mobile Right menu background",
        "Top winners widget background on mobile",
        "Event widget, Sidebar selected tab and items background in Sportsbook",
    ],

    'background-color-4': [
        "Events background in Sportsbook",
    ],

    'background-color-5': [
        "Secondary menu background",
        "Casino Categories section background",
        "Casino default state tab background on mobile",
        "Promotion inner page content background",
        "Regulations menu subitems background",
        "Game grid and single game action icons background in Multi view",
    ],

    'background-color-6': [
        "Footer background",
    ],

    'text-color-1': [
        "Phone number in customer service on footer",
        "App adviser background",
        "Top matches text in Sportsbook",
        "Promotion name, description, popup header and body",
        "Main text color in Sportsbook",
    ],

    'text-color-2': [
        "Top matches line next to the label and match date",
        "Language bar text and icon",
        "Social media icons, Mobile apps icons and text in footer",
        "Odds and markets in Sportsbook",
    ],

    'text-color-3': [
        "Secondary menu items in header",
        "Subitems in Right menu on mobile",
        "Text and close icon in Cookies",
        "Main menu subitems, secondary menu items and labels in Left menu on mobile",
        "Announcement text and arrows",
        "Regulations menu items, subitems and body text",
    ],

    'text-color-4': [
        "Main menu items, subitems and secondary menu subitems",
        "Default state menu items in mobile navigation bar",
        "Sidebar menu items and subitems, tooltip texts",
        "Featured Products text",
        "Block name, about company text and menus in footer",
        "Top winners widget label, ID and date",
        "Default state categories in Casino and Promotions",
    ],

    // Template 5 Color Descriptons
    'brand-color-pop-1': [
        "Unread messages count in header",
        "Copyright info in footer",
        "Selected and hovered odds in Sportsbook",
        "Hovered Featured Products",
        "Secondary and tertiary in Account popups and all buttons in Sportsbook",
        "Illustrations (partially) in Account popups",
    ],

    'brand-color-pop-2': [
        "All buttons in pages and Primary buttons in Account popups",
        "Selected menu items and subitems in header",
        "Sidebar background",
        "Selected item in mobile navigation bar",
        "Selected menu item in Right and Left menus on mobile",
        "Floating menu item",
        "Popups header background",
        "Selected tab and sidebar item in Sportsbook",
    ],

    'brand-color-pop-text': [
        "Default tabs in Account popups on desktop",
        "Selected and hovered odds text in Sportsbook", 
        "Selected tab text in Sportsbook",
    ],

    'background-color-pop-1': [
        "Header background",
        "Mobile navigation bar items background",
        "Main menu subitems background",
        "Left menu background on mobile",
        "Regulations menu and body background",
        "Sport Jackpot and Top winners background",
        "Top matches background",
        "Sportsbook background",
    ],

    'background-color-pop-2': [
        "Website inner pages background",
        "Right menu background on mobile",
        "Casino filter popup background on mobile",
        "Promotion popup background",
        "Default odds background in Sportsbook",
        "Event dropdown and header background in Sportsbook",
    ],

    'background-color-pop-3': [
        "Secondary menu subitems background",
        "Mobile Left menu subitems background",
        "Top winners widget background on mobile",
        "Event widget, Sidebar selected tab and items background in Sportsbook",
    ],

    'background-color-pop-4': [
        "Leagues background in Sportsbook",
    ],

    'background-color-pop-5': [
        "Secondary menu background",
        "Customer service and Mobile apps background",
        "Casino categories and Providers sidebar background",
        "Announcement background",
        "Promotion inner page body background",
    ],

    'background-color-pop-6': [
        "Footer background",
    ],

    'text-color-pop-1': [
        "App adviser background",
        "Cookies text color",
        "Promotion name and description",
        "Top matches text in Sportsbook",
        "Main text color in Sportsbook",
    ],

    'text-color-pop-2': [
        "Language bar and dropdown items",
        "Featured Product icon and text",
        "Announcement text, close and arrow icons",
        "Default menu items and body in Rules",
        "Odds and markets in Sportsbook",
    ],

    'text-color-pop-3': [
        "Footer texts and social media icons",
        "Announcement details popup text",
        "Timezone text",
        "Provider games count and checkbox in sidebar",
    ],

    'text-color-pop-4': [
        "Main and Secondary menu items and subitems",
        "Default state menu items in mobile navigation bar",
        "Top winners widget label, ID and date",
        "Default state categories in Casino and Promotions",
    ],
  }
};

export default ru;